var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{attrs:{"default-active-key":"1"},on:{"change":_vm.tabChange}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"当班日志"}},[_c('OperationRecord')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"交接班记录"}},[_c('YwDutyRecord')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }